import React, { Component } from 'react'
import {
  NavBar,
  WhiteSpace,
  WingBlank,
  List,
  Icon,
  Button,
  InputItem,
  Picker,
  Toast
} from 'antd-mobile'
import './deviceInfo.scss'
import {createForm} from 'rc-form'
import axios from 'axios'
import UserSelectGroups from '../../userManage/userAdd/userSelectGroup'
import DefaultGroup from '../../userManage/userAdd/defaultGroup'
import { connect } from 'dva'

const Item = List.Item

const selectedContainer = {
  position: "fixed",
  width: "100%",
  top: "0px",
  background: "#f5f5f5",
  height: "100%",
  zIndex: "11",
  transition: "left 0.4s",
}

// 设备在组内讲话优先级列表数据
const priorityInfo = [
  { label: <div key='0'>普通账号优先</div>,value: 0 },
  { label: <div key='1'>设备账号优先</div>,value: 1 },
  { label: <div key='2'>相同优先级</div>,value: 2 },
]

// 色码项选择列表数据
const dmr_cc = [
    { label : <div key='0'>色码0</div>, value : 0 },
    { label : <div key='1'>色码1</div>, value : 1 },
    { label : <div key='2'>色码2</div>, value : 2 },
    { label : <div key='3'>色码3</div>, value : 3 },
    { label : <div key='4'>色码4</div>, value : 4 },
    { label : <div key='5'>色码5</div>, value : 5 },
    { label : <div key='6'>色码6</div>, value : 6 },
    { label : <div key='7'>色码7</div>, value : 7 },
    { label : <div key='8'>色码8</div>, value : 8 },
    { label : <div key='9'>色码9</div>, value : 9 },
    { label : <div key='10'>色码10</div>, value : 10 },
    { label : <div key='11'>色码11</div>, value : 11 },
    { label : <div key='12'>色码12</div>, value : 12 },
    { label : <div key='13'>色码13</div>, value : 13 },
    { label : <div key='14'>色码14</div>, value : 14 },
    { label : <div key='15'>色码15</div>, value : 15 },
]

// 亚音模式项选择列表数据
const ctcss_type = [
  { label: <div>无亚音</div>, value: 0 },
  { label: <div>模拟亚音</div>, value: 1 },
  { label: <div>数字亚音N</div>, value: 2 },
  { label: <div>数字亚音I</div>, value: 3 },
]

// 模拟亚音参数,共50组
const ctcss_type_1 = [
  { label: <div>67.0</div>, value: 67.0},
  { label: <div>69.3</div>, value: 69.3},
  { label: <div>71.9</div>, value: 71.9},
  { label: <div>74.4</div>, value: 74.4},
  { label: <div>77.0</div>, value: 77.0},
  { label: <div>79.7</div>, value: 79.7},
  { label: <div>82.5</div>, value: 82.5},
  { label: <div>85.4</div>, value: 85.4},
  { label: <div>88.5</div>, value: 88.5},
  { label: <div>91.5</div>, value: 91.5},
  { label: <div>94.8</div>, value: 94.8},
  { label: <div>97.4</div>, value: 97.4},
  { label: <div>100.0</div>, value: 100.0},
  { label: <div>103.5</div>, value: 103.5},
  { label: <div>107.2</div>, value: 107.2},
  { label: <div>110.9</div>, value: 110.9},
  { label: <div>114.8</div>, value: 114.8},
  { label: <div>118.8</div>, value: 118.8},
  { label: <div>123.0</div>, value: 123.0},
  { label: <div>127.3</div>, value: 127.3},
  { label: <div>131.8</div>, value: 131.8},
  { label: <div>136.5</div>, value: 136.5},
  { label: <div>141.3</div>, value: 141.3},
  { label: <div>146.2</div>, value: 146.2},
  { label: <div>151.4</div>, value: 151.4},
  { label: <div>156.7</div>, value: 156.7},
  { label: <div>159.8</div>, value: 159.8},
  { label: <div>162.2</div>, value: 162.2},
  { label: <div>165.5</div>, value: 165.5},
  { label: <div>167.9</div>, value: 167.9},
  { label: <div>171.3</div>, value: 171.3},
  { label: <div>173.8</div>, value: 173.8},
  { label: <div>177.3</div>, value: 177.3},
  { label: <div>179.9</div>, value: 179.9},
  { label: <div>183.5</div>, value: 183.5},
  { label: <div>186.2</div>, value: 186.2},
  { label: <div>189.9</div>, value: 189.9},
  { label: <div>192.8</div>, value: 192.8},
  { label: <div>196.6</div>, value: 196.6},
  { label: <div>199.5</div>, value: 199.5},
  { label: <div>203.5</div>, value: 203.5},
  { label: <div>206.5</div>, value: 206.5},
  { label: <div>210.7</div>, value: 210.7},
  { label: <div>218.1</div>, value: 218.1},
  { label: <div>225.7</div>, value: 225.7},
  { label: <div>229.1</div>, value: 229.1},
  { label: <div>233.6</div>, value: 233.6},
  { label: <div>241.8</div>, value: 241.8},
  { label: <div>250.3</div>, value: 250.3},
  { label: <div>254.1</div>, value: 254.1},
]

// 数字亚音(N与I共用)参数,共116组
const ctcss_type_2 = [
  { label: <div>017</div>, value: 17 },
  { label: <div>023</div>, value: 23 },
  { label: <div>025</div>, value: 25 },
  { label: <div>026</div>, value: 26 },
  { label: <div>031</div>, value: 31 },
  { label: <div>032</div>, value: 32 },
  { label: <div>036</div>, value: 36 },
  { label: <div>043</div>, value: 43 },
  { label: <div>047</div>, value: 47 },
  { label: <div>050</div>, value: 50 },
  { label: <div>051</div>, value: 51 },
  { label: <div>053</div>, value: 53 },
  { label: <div>054</div>, value: 54 },
  { label: <div>055</div>, value: 55 },
  { label: <div>065</div>, value: 65 },
  { label: <div>071</div>, value: 71 },
  { label: <div>072</div>, value: 72 },
  { label: <div>073</div>, value: 73 },
  { label: <div>074</div>, value: 74 },
  { label: <div>114</div>, value: 114 },
  { label: <div>115</div>, value: 115 },
  { label: <div>116</div>, value: 116 },
  { label: <div>122</div>, value: 122 },
  { label: <div>125</div>, value: 125 },
  { label: <div>131</div>, value: 131 },
  { label: <div>132</div>, value: 132 },
  { label: <div>134</div>, value: 134 },
  { label: <div>135</div>, value: 135 },
  { label: <div>143</div>, value: 143 },
  { label: <div>145</div>, value: 145 },
  { label: <div>152</div>, value: 152 },
  { label: <div>155</div>, value: 155 },
  { label: <div>156</div>, value: 156 },
  { label: <div>162</div>, value: 162 },
  { label: <div>165</div>, value: 165 },
  { label: <div>172</div>, value: 172 },
  { label: <div>174</div>, value: 174 },
  { label: <div>205</div>, value: 205 },
  { label: <div>212</div>, value: 212 },
  { label: <div>217</div>, value: 217 },
  { label: <div>223</div>, value: 223 },
  { label: <div>225</div>, value: 225 },
  { label: <div>226</div>, value: 226 },
  { label: <div>243</div>, value: 243 },
  { label: <div>244</div>, value: 244 },
  { label: <div>245</div>, value: 245 },
  { label: <div>246</div>, value: 246 },
  { label: <div>251</div>, value: 251 },
  { label: <div>252</div>, value: 252 },
  { label: <div>254</div>, value: 254 },
  { label: <div>255</div>, value: 255 },
  { label: <div>261</div>, value: 261 },
  { label: <div>263</div>, value: 263 },
  { label: <div>265</div>, value: 265 },
  { label: <div>266</div>, value: 266 },
  { label: <div>271</div>, value: 271 },
  { label: <div>274</div>, value: 274 },
  { label: <div>305</div>, value: 305 },
  { label: <div>306</div>, value: 306 },
  { label: <div>311</div>, value: 311 },
  { label: <div>315</div>, value: 315 },
  { label: <div>325</div>, value: 325 },
  { label: <div>331</div>, value: 331 },
  { label: <div>332</div>, value: 332 },
  { label: <div>343</div>, value: 343 },
  { label: <div>345</div>, value: 345 },
  { label: <div>346</div>, value: 346 },
  { label: <div>351</div>, value: 351 },
  { label: <div>356</div>, value: 356 },
  { label: <div>364</div>, value: 364 },
  { label: <div>365</div>, value: 365 },
  { label: <div>371</div>, value: 371 },
  { label: <div>411</div>, value: 411 },
  { label: <div>412</div>, value: 412 },
  { label: <div>413</div>, value: 413 },
  { label: <div>423</div>, value: 423 },
  { label: <div>425</div>, value: 425 },
  { label: <div>431</div>, value: 431 },
  { label: <div>432</div>, value: 432 },
  { label: <div>445</div>, value: 445 },
  { label: <div>446</div>, value: 446 },
  { label: <div>452</div>, value: 452 },
  { label: <div>454</div>, value: 454 },
  { label: <div>455</div>, value: 455 },
  { label: <div>462</div>, value: 462 },
  { label: <div>464</div>, value: 464 },
  { label: <div>465</div>, value: 465 },
  { label: <div>466</div>, value: 466 },
  { label: <div>503</div>, value: 503 },
  { label: <div>506</div>, value: 506 },
  { label: <div>516</div>, value: 516 },
  { label: <div>523</div>, value: 523 },
  { label: <div>526</div>, value: 526 },
  { label: <div>532</div>, value: 532 },
  { label: <div>534</div>, value: 534 },
  { label: <div>546</div>, value: 546 },
  { label: <div>565</div>, value: 565 },
  { label: <div>606</div>, value: 606 },
  { label: <div>612</div>, value: 612 },
  { label: <div>624</div>, value: 624 },
  { label: <div>627</div>, value: 627 },
  { label: <div>631</div>, value: 631 },
  { label: <div>632</div>, value: 632 },
  { label: <div>645</div>, value: 645 },
  { label: <div>654</div>, value: 654 },
  { label: <div>662</div>, value: 662 },
  { label: <div>664</div>, value: 664 },
  { label: <div>703</div>, value: 703 },
  { label: <div>712</div>, value: 712 },
  { label: <div>723</div>, value: 723 },
  { label: <div>731</div>, value: 731 },
  { label: <div>732</div>, value: 732 },
  { label: <div>734</div>, value: 734 },
  { label: <div>743</div>, value: 743 },
  { label: <div>754</div>, value: 754 },
  { label: <div>765</div>, value: 765 },
]

// 功率模式参数列表
const fm_pwd = [
  { label: <div>低功率</div>, value: 0 },
  { label: <div>高功率</div>, value: 1 },
]

// 模拟宽窄带参数列表
const fm_width = [
  { label: <div>窄带</div>, value: 0 },
  { label: <div>宽带</div>, value: 1 },
]

@connect()
export class SetDeviceInfo extends Component {
  state = {
    priority: [2],  // 组内优先级
    mode: 'dmr',  // 模式, 默认dmr模式
    defaultGid: "",

    // TX_FREQ: '',  // 发射频率,由用户输入
    // RX_FREQ: '',  // 接收频率,由用户输入

    drawerLeft: document.body.clientWidth,
    drawerLeftDefault: document.body.clientWidth,
    deviceInfo:{
      id: '',   // 设备id
      dmrName:'',  // 设备名称
      name:'',  // 账号名称
    },   // 设备数据初始化对象
    DMRCfg:{
      DMR_CC: [0], // 色码，默认0
    },
    FMCfg:{
      RX_CTCSS_TYPE: [0],  //  接收亚音模式,默认无亚音
      RX_CTCSS_VAL: [0],  // 接收亚音的值
      TX_CTCSS_TYPE: [0],  //  发射亚音模式,默认无亚音
      TX_CTCSS_VAL: [0],  // 发射亚音的值
      FM_PWR: [0],  // 功率,默认低功率
      FM_WIDTH: [0],  // 宽窄带模式, 默认窄带
    }
  }

  async componentWillMount() {
    this.props.emptyGroups();
    await this.getDeviceInfoById(this.props.location.search.split("?")[1])
    this.getConfigInfo(this.state.deviceInfo.dmrCfg,this.state.deviceInfo.digitCfg)
  }

  // 获取设备详情信息
  getDeviceInfoById(deviceId){
    return new Promise( rev =>{
      axios
      .post(
        '/api/dmrgw/wechat/detail',{id:deviceId}
      ).then((res)=>{
        rev()
        // console.log(res,rev(),'getDeviceInfoById?')
        if (res && res.status === 200){
          // 填充所属群组
          this.getUserIsIngroup(res.data)
          // 填充默认群组数据
          this.props.addDefaultGroup({
            name: res.data.defaultGidName,
            gid: res.data.defaultGid,
          })
          // 填充页面数据
          this.getInterfaceToInfo(res.data)
          

        }else{
          Toast.fail(res.message)
        }
      })
    })
    
  }

  // 初始化页面数据
  getInterfaceToInfo(e){

    // 填充账号基本数据
    this.setState({
      deviceInfo: e
    })
    
    // 判断当前终端账号优先级
    if (e.priority == 0){
      this.setState ({priority:[0]})
    } else if (e.priority == 1){
      this.setState ({priority:[1]})
    } else {
      this.setState ({priority:[2]})
    }

    // 判断设备当前类型 
    if (e.mode == 'digit'){
      this.setState ({mode:'digit'})
    } else { 
      this.setState ({mode:'dmr'})
    }
  }

  // 获取终端账号所属群组
  getUserIsIngroup(e){
    return new Promise( rev => {
      console.log('id?',e)
      axios
        .post('/api/user/ptt/groups',{
          page: { pageNo: 1, pageSize: 2500 },
          uid: e.vuid
        })
        .then( res => {
          rev()
          if (res.data && res.status ==200){
            this.props.setGroups(res.data.resultList)
          }
        })
        .catch(()=>{
          Toast.hide();
        })
    })
  }

  // 解析Config字段
  getConfigInfo(dmrCfg,digitCfg){
    if( dmrCfg && digitCfg ){
      // 解析dmr配置
      let DMR_Cfg_Arr = dmrCfg.split(";")
      let DMR_Obj = {} 
      DMR_Cfg_Arr.map((item) => {
          let str = item.split(":")
          str[1] = str[0] === 'DMR_CC'?str[1]=[Number(str[1])]:str[1]
          DMR_Obj[str[0]] = str[1]
        })
      this.setState({DMRCfg:DMR_Obj})
      
      // 解析digit配置
      let FM_Cfg_Arr = digitCfg.split(";")
      let FM_Obj = {} 
      FM_Cfg_Arr.map((item) => {
          let str = item.split(":")
          str[1] = str[0] === 'RX_CTCSS_TYPE'?str[1]=[Number(str[1])]:str[1]
          str[1] = str[0] === 'TX_CTCSS_TYPE'?str[1]=[Number(str[1])]:str[1]
          str[1] = str[0] === 'RX_CTCSS_VAL'?str[1]=[Number(str[1])]:str[1]
          str[1] = str[0] === 'TX_CTCSS_VAL'?str[1]=[Number(str[1])]:str[1]
          str[1] = str[0] === 'FM_PWR'?str[1]=[Number(str[1])]:str[1]
          str[1] = str[0] === 'FM_WIDTH'?str[1]=[Number(str[1])]:str[1]
          FM_Obj [str[0]] = str[1]
        })
      this.setState({FMCfg:FM_Obj})
    }
  }
  
  // 确认按钮提交
  sunmit(){
    this.props.form.validateFields({force: true}, error => {
      console.log(error,'err?')
      if(!error){
        const fildsValue = this.props.form.getFieldsValue();
        // console.log(fildsValue,'fildsValue?')
        // console.log(this.state,'state?')
        // console.log(this.state.deviceInfo,'Info')
        // console.log(this.state.deviceInfo.id,'id')
        // console.log(fildsValue.dmrName,'设备名称')
        // console.log(fildsValue.name,'账号名称')
        // console.log(fildsValue.joinGidList,'进入的群组')
        // console.log(fildsValue.defaultGid,'默认群组')
        // console.log(this.state.priority,'优先级')
        // console.log(this.state.mode,"类型")

        // console.log(fildsValue.TX_FREQ,"发射频率")
        // console.log(fildsValue.RX_FREQ,"接收频率")

        // console.log(this.state.DMRCfg.DMR_CC,"色码")
        // console.log(this.state.FMCfg.RX_CTCSS_TYPE,"接收亚音的模式")
        let rx_val = 0
        if (this.state.FMCfg.RX_CTCSS_TYPE[0] != 0) {
          rx_val = this.state.FMCfg.RX_CTCSS_VAL
        }
        // console.log(rx_val,"接收亚音的值")
        // console.log(this.state.FMCfg.TX_CTCSS_TYPE,"发送亚音的模式")
        let tx_val = 0
        if (this.state.FMCfg.TX_CTCSS_TYPE[0] != 0) {
          tx_val = this.state.FMCfg.TX_CTCSS_VAL
        }
        // console.log(tx_val,"发送亚音的值")
        // console.log(this.state.FMCfg.FM_PWR,"功率模式")
        // console.log(this.state.FMCfg.FM_WIDTH,"宽窄带模式")
        

        // 接口数据拼接
        const dmrCfg = 'MODE:DMR;RX_FREQ:'+ fildsValue.RX_FREQ + 
              ';TX_FREQ:'+ fildsValue.TX_FREQ +
              ';DMR_CC:'+ this.state.DMRCfg.DMR_CC
        const digitCfg = 'MODE:FM;RX_FREQ:'+ fildsValue.RX_FREQ +
              ';TX_FREQ:'+ fildsValue.TX_FREQ +
              ';RX_CTCSS_TYPE:' + this.state.FMCfg.RX_CTCSS_TYPE +
              ';RX_CTCSS_VAL:' + rx_val +
              ';TX_CTCSS_TYPE:' + this.state.FMCfg.TX_CTCSS_TYPE +
              ';TX_CTCSS_VAL:' + tx_val +
              ';FM_PWR:' + this.state.FMCfg.FM_PWR + 
              ';FM_WIDTH:' + this.state.FMCfg.FM_WIDTH
        console.log("dmrCfg:",dmrCfg)
        console.log("digitCfg:",digitCfg)
        
        axios
          .post('api/dmrgw/wechat/set',{
            id: this.state.deviceInfo.id,
            dmrName: fildsValue.dmrName,
            name: fildsValue.name,
            joinGidList: fildsValue.joinGidList,
            defaultGid: fildsValue.defaultGid,
            priority: fildsValue.priority[0],
            mode: this.state.mode,
            digitCfg,
            dmrCfg,
          })
          .then(res=>{
            console.log('res?',res)
            if(res && res.status == 200){
              Toast.success(res.message,1.5)
              window.history.go(-1);
            } else {
              Toast.fail(res.message,1.5)
            }
          })
      }
    })
  }

  // 验证输入的终端账号名称
  validateUserName = (rule, value, callback) => {
    if (value) {
      if (value.trim()) {
        if (!/^[a-zA-Z0-9_\u4e00-\u9fa5]{0,16}$/.test(value)) {
          callback(new Error("名字只支持0-16位的中文、数字、字母或下划线"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    } else {
      callback();
    }
  }

  // 验证选择加入的群组
  validateInGroups = (rule, value, callback) => {
    if (this.props.groups.length < 1) {
        callback(new Error("请选择用户所在群组"));
    } else {
        callback();
    }
  }

  // 验证选择的默认群组
  validateDefaultGid = (rule, value, callback) => {
    let defaultGroup = this.props.defaultGroup;
    if (defaultGroup && defaultGroup.name) {
        callback();
    } else {
        callback(new Error("请选择用户默认群组"));
    }
  }

  // 验证输入的发射频率
  validateTX_FREQ = (rule, value, callback) => {
    if (~~value != 0){
      if (value > 470 || value < 400 ) {
        callback(new Error("请填写400~470之间的频率"))
      }
      if (value.length > 7 || value.length < 2) {
        callback(new Error("输入长度限制6位"))
      }
      callback()
    } else {
      callback(new Error("请填写正确的发射频率"))
    }
  }
  // 验证输入的接收频率
  validateRX_FREQ = (rule, value, callback) => {
    if (~~value != 0){
      if (value > 470 || value < 400 ) {
        callback(new Error("请填写400~470之间的频率"))
      }
      if (value.length > 7 || value.length < 2) {
        callback(new Error("输入长度限制6位"))
      }
      callback()
    } else {
      callback(new Error("请填写正确的接收频率"))
    }
  } 

  render() {
    const userMsg =
      sessionStorage.getItem('loginMsg') &&
      JSON.parse(sessionStorage.getItem('loginMsg'))
    const { getFieldProps, getFieldError } = this.props.form
    const { 
      groupsGidArr,
      groups,
      addDefaultGroup,
      defaultGroup, 
      match
    } = this.props
    const {
      priority,
      mode,
      drawerLeft,
      drawerLeftDefault,
      deviceInfo,
      DMRCfg,
      FMCfg
    } = this.state
    const {
      dmrName,
      name,
    } = deviceInfo
    const {
      RX_FREQ,
      TX_FREQ,
      DMR_CC
    } = DMRCfg
    const {
      RX_CTCSS_TYPE,
      RX_CTCSS_VAL,
      TX_CTCSS_TYPE,
      TX_CTCSS_VAL,
      FM_PWR,
      FM_WIDTH
    } = FMCfg

    // 点击dmr/digit模式按钮触发的事件
    const onChangeMode = (e) => {
      this.setState({
        mode: e
      })
    }

    return (
      <div className='setDeviceInfo'>
        <div className="header-sticky">
          <NavBar
            icon={<Icon type="left" />}
            onLeftClick={() => this.props.history.goBack()}
          >
            设备信息设置
          </NavBar>
        </div>
        <div className='sub-container'>
          <WhiteSpace/>
          <form>
            <List  
              renderFooter={()=>
                getFieldError("name") ||
                getFieldError("joinGidList") ||
                getFieldError("defaultGid") ||
                getFieldError("TX_FREQ") ||
                getFieldError("RX_FREQ") 
              }
            >
              <WhiteSpace/>
              <InputItem
                {...getFieldProps('dmrName',{
                  rules:[],
                  initialValue: dmrName
                })}
              >
                设备名称: 
              </InputItem>
              <InputItem
                key='2'
                {...getFieldProps('name',{
                  rules:[{validator: this.validateUserName}],
                  initialValue: name
                })}
              >
                账号名称:
              </InputItem>
              {/* 选择多个群组 */}
              <Item
                className='hide-input'
                arrow="horizontal"
                extra = {
                  <span
                    onClick={()=>{ this.setState({ drawerLeft: 0 }) }}
                  >
                    {groupsGidArr.length < 1 
                      ? '选择群组'
                      :`已选择${groupsGidArr.length}个群组` }
                  </span>
                }
                onClick={()=>{ this.setState({ drawerLeft: 0 })}}
                value={groupsGidArr}
                key="3"
                {...getFieldProps("joinGidList",{
                  rules:[{validator: this.validateInGroups}],
                  initialValue: groupsGidArr
                })}
              >
                <i className="red-star">*</i>
                所属群组:
              </Item>
              {/* 默认群组 */}
              <Item
                {...getFieldProps("defaultGid", {
                  rules: [{ validator: this.validateDefaultGid }],
                  initialValue: defaultGroup.gid,
                })}
                className="hide-input"
                arrow="horizontal"
                extra={
                  <span
                    style={{
                        textAlign: " right",
                        width: "50vw",
                        minWidth: "100px",
                        height: "16px",
                    }}
                    onClick={() => {
                      console.log( groupsGidArr, defaultGroup ,'groups?');
                      if (groupsGidArr.length < 1) {
                        Toast.info( "请先选择所属群组", 1.5 );
                      } else {
                        this.setState({ drawerLeftDefault: 0 });
                      }
                    }}
                  >
                    {defaultGroup && defaultGroup.name
                      ? defaultGroup.name
                      : `请选择默认群组`}
                  </span>
                }
                onClick={() => {
                  console.log( groupsGidArr, defaultGroup );
                  if (groupsGidArr.length < 1) {
                    Toast.info( "请先选择所属群组", 1.5 );
                  } else {
                    this.setState({ drawerLeftDefault: 0 });
                  }
                }}
                key="4"
                value={defaultGroup}
              >
                <i className="red-star">*</i>
                默认群组:
              </Item>
              {/* 组内优先级 */}
              <Picker
                key='5'
                data={priorityInfo}
                cols={1}
                value={priority}
                {...getFieldProps('priority',{
                  rules:[],
                  initialValue: priority
                })}
              >
                <Item>组内优先级:</Item>
              </Picker>
              <WhiteSpace size='xl'/>
              {/* 模式选择 */}
              <Item
                key='6'
              >
                选择模式:
                <Button 
                  key='6-1'
                  icon={mode == 'dmr' ? 'check-circle-o' : 'ellipsis'} 
                  type={mode == 'dmr' ? 'primary' : ''} 
                  inline size="small" 
                  style={{ marginLeft: '20px' , marginRight: '5px' }} 
                  onClick={() => onChangeMode('dmr')}
                >
                  DMR模式
                </Button>
                <Button 
                  key='6-2'
                  icon={mode == 'digit' ? 'check-circle-o' : 'ellipsis'} 
                  type={mode == 'digit' ? 'primary' : ''} 
                  inline size="small" 
                  onClick={() => onChangeMode('digit')}
                >
                  数字模式
                </Button>
              </Item>
              {/* 发射频率 */}
              <InputItem
                key='7'
                clear
                placeholder = {`请输入400~470MHz之间的频率`}
                type="digit"
                {...getFieldProps('TX_FREQ',{
                  rules:[{validator: this.validateTX_FREQ}],
                  initialValue: TX_FREQ
                })}
              >
                发送频率:
              </InputItem>
              {/* 接收频率 */}
              <InputItem
                key='8'
                clear
                placeholder = {`请输入400~470MHz之间的频率`}
                type="digit"
                {...getFieldProps('RX_FREQ',{
                  rules:[{validator: this.validateRX_FREQ}],
                  initialValue: RX_FREQ
                })}
              >
                接收频率:
              </InputItem>
              {/* dmr 模式下显示的页面 */}
              {mode === "dmr" ? (
                <div>
                  <Picker
                    data={dmr_cc}
                    cols={1}
                    value={DMR_CC}
                    onChange={v => 
                      this.setState(Object.assign(DMRCfg,{DMR_CC:v}))
                    }
                    onOk={v => 
                      this.setState(Object.assign(DMRCfg,{DMR_CC:v}))
                    }
                    // {...getFieldProps('DMR_CC',{
                    //   rules:[],
                    //   initialValue: DMR_CC
                    // })}
                  >
                    <Item key='1' arrow='horizontal'>
                      选择色码
                    </Item>
                  </Picker>
                </div>
              ) : (
                ""
              )}

              {/* 模拟 模式下显示的页面 */}
              {mode ==="digit" ? (
                <div>
                  <WhiteSpace  size='xl'/>
                  <span>接收亚音</span>
                  <Picker
                    data={ctcss_type}
                    cols={1}
                    onChange={v => this.setState(Object.assign(FMCfg,{RX_CTCSS_TYPE:v}))}
                    onOk={v => this.setState(Object.assign(FMCfg,{RX_CTCSS_TYPE:v}))}
                    value={RX_CTCSS_TYPE}
                  >
                    <Item>
                      选择亚音模式
                    </Item>
                  </Picker>
                  {/* 判断当前选择的接收亚音模式 */}
                  {RX_CTCSS_TYPE[0] === 0 ?(
                    ""
                  ):(RX_CTCSS_TYPE[0] === 1 ?(
                    <div>
                      <Picker
                      data={ctcss_type_1}
                      cols={1}
                      onChange={v => this.setState(Object.assign(FMCfg,{RX_CTCSS_VAL:v}))}
                      onOk={v => this.setState(Object.assign(FMCfg,{RX_CTCSS_VAL:v}))}
                      value={RX_CTCSS_VAL}
                    >
                      <Item>
                        模拟亚音选择
                      </Item>
                    </Picker>
                    </div>
                  ):(RX_CTCSS_TYPE[0] === 2?(
                    <div>
                      <Picker
                        data={ctcss_type_2}
                        cols={1}
                        onChange={v => this.setState(Object.assign(FMCfg,{RX_CTCSS_VAL:v}))}
                        onOk={v => this.setState(Object.assign(FMCfg,{RX_CTCSS_VAL:v}))}
                        value={RX_CTCSS_VAL}
                      >
                        <Item>
                          数字亚音N选择
                        </Item>
                      </Picker>
                    </div>
                  ):(RX_CTCSS_TYPE[0] === 3?(
                    <div>
                      <Picker
                        data={ctcss_type_2}
                        cols={1}
                        onChange={v => this.setState(Object.assign(FMCfg,{RX_CTCSS_VAL:v}))}
                        onOk={v => this.setState(Object.assign(FMCfg,{RX_CTCSS_VAL:v}))}
                        value={RX_CTCSS_VAL}
                      >
                        <Item>
                          数字亚音I选择
                        </Item>
                      </Picker>
                    </div>
                  ):(""))))}

                  <WhiteSpace size='xl'/>
                  <span>发送亚音</span>
                  <Picker
                    data={ctcss_type}
                    cols={1}
                    onChange={v => this.setState(Object.assign(FMCfg,{TX_CTCSS_TYPE:v}))}
                    onOk={v => this.setState(Object.assign(FMCfg,{TX_CTCSS_TYPE:v}))}
                    value={TX_CTCSS_TYPE}
                  >
                    <Item>
                      选择亚音模式
                    </Item>
                  </Picker>

                  {/* 判断当前选择的发送亚音模式 */}
                  {TX_CTCSS_TYPE[0] === 0 ?(
                    ""
                  ):(TX_CTCSS_TYPE[0] === 1 ?(
                    <div>
                      <Picker
                        data={ctcss_type_1}
                        cols={1}
                        onChange={v => this.setState(Object.assign(FMCfg,{TX_CTCSS_VAL:v}))}
                        onOk={v => this.setState(Object.assign(FMCfg,{TX_CTCSS_VAL:v}))}
                        value={TX_CTCSS_VAL}
                      >
                      <Item>
                        模拟亚音选择
                      </Item>
                    </Picker>
                    </div>
                  ):(TX_CTCSS_TYPE[0] === 2 ?(
                    <div>
                      <Picker
                        data={ctcss_type_2}
                        cols={1}
                        onChange={v => this.setState(Object.assign(FMCfg,{TX_CTCSS_VAL:v}))}
                        onOk={v => this.setState(Object.assign(FMCfg,{TX_CTCSS_VAL:v}))}
                        value={TX_CTCSS_VAL}
                      >
                        <Item>
                          数字亚音N选择
                        </Item>
                      </Picker>
                    </div>
                  ):(TX_CTCSS_TYPE[0] === 3 ?(
                    <div>
                      <Picker
                        data={ctcss_type_2}
                        cols={1}
                        onChange={v => this.setState(Object.assign(FMCfg,{TX_CTCSS_VAL:v}))}
                        onOk={v => this.setState(Object.assign(FMCfg,{TX_CTCSS_VAL:v}))}
                        value={TX_CTCSS_VAL}
                      >
                        <Item>
                          数字亚音I选择
                        </Item>
                      </Picker>
                    </div>
                  ):(""))))}

                  <WhiteSpace size='xl'/>
                  {/* 功率模式 */}
                  <Picker
                    data={fm_pwd}
                    cols={1}
                    onChange={v => this.setState(Object.assign(FMCfg,{FM_PWR:v}))}
                    onOk={v => this.setState(Object.assign(FMCfg,{FM_PWR:v}))}
                    value={FM_PWR}
                  >
                    <Item>
                      功率模式
                    </Item>
                  </Picker>

                  {/* 宽窄带选择 */}
                  <Picker
                    data={fm_width}
                    cols={1}
                    onChange={v => this.setState(Object.assign(FMCfg,{FM_WIDTH:v}))}
                    onOk={v => this.setState(Object.assign(FMCfg,{FM_WIDTH:v}))}
                    value={FM_WIDTH}
                  >
                    <Item>
                      宽窄带选择
                    </Item>
                  </Picker>
                </div>
              ) : ("")}
            </List>
            <WingBlank>
              <WhiteSpace size="xl" />
              <Button type="primary" onClick={() => this.sunmit()}>
                确定
            </Button>
              <WhiteSpace size="xl" />
              <Button type="" onClick={() => window.history.go(-1)}>
                返回
            </Button>
              <WhiteSpace size="xl" />
            </WingBlank>
          </form>
          <WhiteSpace/>
        </div>
        <div
          style={{
            ...selectedContainer,
            left: drawerLeft + "px",
          }}
        >
          <UserSelectGroups
            defaultGroup={defaultGroup}
            addDefaultGroup={addDefaultGroup}
            uid={match.params.id}
            handleChildClose={() =>
              this.setState({
                drawerLeft: document.body.clientWidth,
              })
            }
          />
        </div>
        <div
          style={{
            ...selectedContainer,
            left: drawerLeftDefault + "px",
            overflowY: "scroll",
            paddingBottom: "45",
          }}
        >
          <DefaultGroup
            selectList={groups}
            addDefaultGroup={addDefaultGroup}
            defaultGroup={defaultGroup}
            handleChildClose={() => {
              this.setState({
                drawerLeftDefault: document.body.clientWidth,
              });
            }}
          />
        </div>
      </div>
    )
  }
}

const SetDevice = createForm()(SetDeviceInfo)
const mapStateToProps = state => {
  return {
    groups: state.group.groups,
    groupsGidArr: state.group.groupsGidArr,
    defaultGroup: state.group.defaultGroup,
  }
}
const mapDispatchToProps = dispatch => {
  return {
    addDefaultGroup: group => {
      dispatch({
        type: "group/addToDefaultGroup",
        payload: {
            group,
        },
      });
    },
    setGroups: data => {
      dispatch({
        type: "group/setGroups",
        data,
      });
    },
    emptyGroups: () => {
      dispatch({
          type: "group/emptyGroups",
      });
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SetDevice)